import React from 'react';
import { Dayjs } from 'dayjs';
import { StyledPickersDay } from 'views/rebranded-module/common/components/Logical/MainWidgetV2/components/HighlightedPriceDay/HighlightedPriceDay.styles';

interface HighlightedDateItem {
  date: string;
  price_category: 'low' | 'medium' | 'high';
}

// ✅ Extend StyledPickersDay's props & add highlightLevel
interface HighlightedPriceDayProps
  extends Omit<React.ComponentProps<typeof StyledPickersDay>, 'day'> {
  day: Dayjs;
  highlightDatesList?: HighlightedDateItem[];
  highlightLevel?: 'low' | 'medium' | 'high';
}

export const HighlightedPriceDay: React.FC<HighlightedPriceDayProps> = ({
  day,
  highlightDatesList = [],
  ...other
}) => {
  const formatted = day.format('YYYY-MM-DD');
  const highlightLevel = highlightDatesList.find(
    (item) => item.date === formatted,
  )?.price_category;

  return (
    <StyledPickersDay {...other} day={day} highlightLevel={highlightLevel} />
  );
};
